<ng-container *ngIf="windowStartDate && windowEndDate">
  <div
    class="ticket-transfer-window-status"
    [ngClass]="{
      open: windowStatus() === 'windowOpen',
      closed: windowStatus() === 'windowClosed',
      'not-open': windowStatus() === 'windowNotOpen',
      'no-transfers': windowStatus() === 'noAvailableTransfers',
    }"
  >
    <ng-container [ngSwitch]="windowStatus()">
      <ng-container *ngSwitchCase="'windowNotOpen'">
        <span> {{ 'fgbcl.ticket.transfer.status.bar.not.open' | translate }}</span>
        <span>{{ 'fgbcl.ticket.transfer.status.bar.not.open.status' | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase="'windowClosed'">
        <span>{{ 'fgbcl.ticket.transfer.status.bar.closed' | translate }}</span>
        <span>{{ 'fgbcl.ticket.transfer.status.bar.closed.status' | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchCase="'noAvailableTransfers'">
        <span>{{ 'fgbcl.ticket.transfer.status.bar.no.available.tickets' | translate }}</span>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <span>{{ 'fgbcl.ticket.transfer.status.bar.open.window' | translate }}</span>
        <fgbcl-countdown [endDateTime]="windowEndDate"></fgbcl-countdown>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
